import { FaFacebook, FaInstagram } from 'react-icons/fa';
import './index.scss';
import Link from 'next/link';
import Image from "next/image";


export default function Footer() {
  return (
    <>
      <footer className="bg-black text-white pt-20 pb-4 relative">
        {/* <div className="bg-[url(/home/footer-black.webp)] absolute footer-top-img">
        </div> */}
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Logo and Social Icons */}
            <div>
              <a href="javascript:void(0)" aria-label="footer-logo" className="block">
                <Image
                  width={150}
                  height={62}
                  src="/shared/logo-white.webp"
                  alt="logo-white"
                ></Image>
              </a>
              <p className="mt-2 text-gray-400">
                We’re Providing Everyday Fresh and Quality Products.


              </p>
              <div className="flex space-x-3 mt-4">
                <Link target="_blank" href="https://www.instagram.com/tablaindiancatering" aria-label="instagram" className="cursor-pointer footer-social w-8 h-8 flex items-center justify-center rounded-full text-white text-2xl transition-all duration-300 hover:scale-110">
                  <FaInstagram className='text-sm' />
                </Link>
                <Link target="_blank" href="https://m.facebook.com/tablaindiancatering" aria-label="facebook" className="cursor-pointer footer-social w-8 h-8 flex items-center justify-center rounded-full text-white text-2xl transition-all duration-300 hover:scale-110">
                  <FaFacebook className='text-sm' />
                </Link>
                {/* <Link target="_blank" href="https://x.com/tablacuisine" aria-label="twitter" className="cursor-pointer footer-social w-8 h-8 flex items-center justify-center rounded-full text-white text-2xl transition-all duration-300 hover:scale-110">
                  <FaTwitter className='text-sm' />
                </Link> */}
                {/* <Link target="_blank" href="https://www.youtube.com/@Tablacuisine" aria-label="youtube" className="cursor-pointer footer-social w-8 h-8 flex items-center justify-center rounded-full text-white text-2xl transition-all duration-300 hover:scale-110">
                  <FaYoutube className='text-sm' />
                </Link> */}
              </div>
            </div>

            {/* Explore Links */}
            <div>
              <h3 className="text-xl font-semibold mb-4">Explore</h3>
              <ul className="space-y-2 footer-menu-links">
                <li className='mb-2'>
                  <Link  href="/" className="text-gray-400">
                    Home
                  </Link>
                </li>
                <li className='mb-2'>
                  <Link  href="/#about" className="text-gray-400">
                    About Us
                  </Link>
                </li>
                <li className='mb-2'>
                  <Link  href="/#order" className="text-gray-400">
                    Order
                  </Link>
                </li>
                <li className='mb-2'>
                  <Link  href="/blogs" className="text-gray-400">
                    Blogs
                  </Link>
                </li>
                {/* <li className='mb-2'>
                  <Link  href="/services" className="text-gray-400">
                    Services
                  </Link>
                </li> */}
                <li className='mb-2'>
                  <Link  href="/#recognized-by" className="text-gray-400">
                    Recognized By
                  </Link>
                </li>
                <li className='mb-2'>
                  <Link  href="/#menu" className="text-gray-400">
                    Menu
                  </Link>
                </li>
                <li className='mb-2'>
                  <Link  href="/#faq" className="text-gray-400">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact & Location */}
            <div>
              <h3 className="text-xl font-semibold mb-4">Contact</h3>
              <p className="text-gray-400">
                5829 Grand National Dr Ballroom Building, Orlando, FL 32819, United States


              </p>
              <p className="mt-2 mb-3">
                <Link target="_blank" href="tel:+14077264020" className="cursor-pointer text-gray-200 underline">
                  +1 407-726-4020
                </Link>
              </p>
              <p>
                <Link target="_blank" href="mailto:tablawinterpark@tablacuisine.com" className="cursor-pointer text-gray-200">
                  tablacatering@tablacuisine.com
                </Link>
              </p>
            </div>


            {/* Location */}
            {/* <div>
              <h3 className="text-xl font-semibold mb-4">Location</h3>
              <iframe
                title="Location"
                className='w-full rounded-lg'
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8502.13287663368!2d-81.35344862379326!3d28.599035675683094!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e771d55c3b580d%3A0xca0e4013ff2d8839!2sTabla%20Indian%20Restaurant%20Winter%20Park!5e1!3m2!1sen!2sus!4v1740856946831!5m2!1sen!2sus"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />

            </div> */}

          </div>


          {/* Bottom Bar */}
          <div className="border-t border-gray-700 mt-8 pt-4 flex flex-col md:flex-row justify-between items-center text-gray-400">
            <p>© 2025 Tabla Cuisine ®. All rights reserved</p>
            <div className="flex space-x-4">
              <Link target="_blank" href="https://www.tablacuisine.com/terms-and-condition" className="cursor-pointer hover:text-white">
                Terms of Services
              </Link>
              <span>/</span>
              <Link target="_blank" href="https://www.tablacuisine.com/privacy-policy" className="cursor-pointer hover:text-white">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

